import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const SignIn = ({ onSignIn }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Set the default header when component mounts if token exists
    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await axios.post('https://admindashboard.clns.in/api/dashboard/login/', {
                email,
                password,
            });
            console.log(response)

            const token = response.data.access_token;
            localStorage.setItem('token', token);

            if (onSignIn) {
                onSignIn();
            }

            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            navigate('/lawyers', { replace: true });
        } catch (err) {
            console.error('Login error:', err);
            setError(err.response?.data?.message || 'Failed to sign in. Please check your credentials.');
        } finally {
            setLoading(false);
        }
    };

    const pageStyles = {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        padding: '20px',
        width:'100%'
    };

    const containerStyles = {
        width: '100%',
        maxWidth: '400px',
        backgroundColor: '#ffffff',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
    };

    const headerStyles = {
        marginBottom: '30px',
        textAlign: 'center'
    };

    const titleStyles = {
        fontSize: '24px',
        fontWeight: 'bold',
        color: '#333333',
        marginBottom: '10px'
    };

    const formGroupStyles = {
        marginBottom: '20px'
    };

    const labelStyles = {
        display: 'block',
        marginBottom: '8px',
        fontSize: '14px',
        fontWeight: '500',
        color: '#333333'
    };

    const inputStyles = {
        width: '100%',
        padding: '10px',
        fontSize: '14px',
        border: '1px solid #cccccc',
        borderRadius: '4px',
        boxSizing: 'border-box'
    };

    const buttonStyles = {
        width: '100%',
        padding: '12px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#ffffff',
        backgroundColor: '#007bff',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        opacity: loading ? '0.7' : '1'
    };

    const errorStyles = {
        marginTop: '10px',
        padding: '10px',
        color: '#dc3545',
        backgroundColor: '#f8d7da',
        border: '1px solid #f5c6cb',
        borderRadius: '4px',
        fontSize: '14px'
    };

    return (
        <div style={pageStyles}>
            <div style={containerStyles}>
                <div style={headerStyles}>
                    <h1 style={{ ...titleStyles, fontSize: '28px' }}>CLNS</h1>
                    <h2 style={titleStyles}>Sign In</h2>
                </div>

                <form onSubmit={handleSubmit}>
                    <div style={formGroupStyles}>
                        <label style={labelStyles}>Email:</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            style={inputStyles}
                        />
                    </div>

                    <div style={formGroupStyles}>
                        <label style={labelStyles}>Password:</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={inputStyles}
                        />
                    </div>

                    {error && (
                        <div style={errorStyles}>
                            {error}
                        </div>
                    )}

                    <button 
                        type="submit" 
                        disabled={loading}
                        style={{
                            ...buttonStyles,
                            cursor: loading ? 'not-allowed' : 'pointer'
                        }}
                    >
                        {loading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default SignIn;